export default class GalleryModal extends HTMLElement {
    constructor() {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.modalTranslations = this.getAttribute('translations');
        this.modalTransJson = null;
        this.id = this.getAttribute('data-gallery-modal');
        this.itemBackClickListener = this.getAttribute('item-back-click-listener');
        this.showGalleryList = true;
        this.eventDelegation();
    }

    static get observedAttributes() {
        return ['stylesheet', 'translations', 'show', 'show-gallery-list'];
    }

    isOpened() {
        return this.modalContainer ? this.modalContainer.classList.contains('show') : false;
    }

    eventDelegation() {
        document.addEventListener('keydown', function (e) {
            if (this.isOpened() && (e.key == 'Escape' || e.key == 'Esc' || e.keyCode == 27)) {
                e.preventDefault();
                let itemClick = document.querySelector(this.itemBackClickListener);
                if (!itemClick && this.shadowRoot) {
                    itemClick = this.shadowRoot.querySelector(this.itemBackClickListener);
                }

                if (!itemClick || itemClick.onClickBack(this.showGalleryList) === false) {
                    this._dismissModal();
                    let hotelGallery = document.querySelector('[data-target="gallery-hotel"]');
                    if (hotelGallery) {
                        hotelGallery.click();
                    }
                }
            }
        }.bind(this), true);
    }

    connectedCallback() {
        let shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#gallery-modal-template');
        if (!t) {
            return;
        }

        const instance = t.content.cloneNode(true);

        this.modalTransJson = JSON.parse(this.modalTranslations);

        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        this.closeModalResponsive = instance.querySelectorAll('[data-dismiss="modal-responsive"]');
        this.closeBackgroundModal = instance.querySelector('[data-container="modal-background"]');
        this.modalContainer = instance.querySelector('[data-container="modal-container"]');

        if (this.getAttribute('data-class')) {
            instance.querySelector('[data-container="modal-container"]').classList.add(this.getAttribute('data-class'));
        }

        this.closeModalResponsive.forEach((element) => {
            element.addEventListener('click', () => {
                let itemClick = document.querySelector(this.itemBackClickListener);
                if (!itemClick && this.shadowRoot) {
                    itemClick = this.shadowRoot.querySelector(this.itemBackClickListener);
                }

                if (!itemClick || itemClick.onClickBack(this.showGalleryList) === false) {
                    this._dismissModal();
                    let hotelGallery = document.querySelector('[data-target="gallery-hotel"]');
                    if (hotelGallery) {
                        hotelGallery.click();
                    }
                }
            });
        });

        this.closeBackgroundModal.onclick = e => {
            this._dismissModal(this.closeBackgroundModal);
        };
        let openModalElement = document.querySelectorAll(`[data-open-modal="${this.id}"]`);
        let closeModalElement = document.querySelector(`[data-close-modal="${this.id}"]`);
        this.buildOpenModalClickEvent(openModalElement);
        this.buildCloseModalClickEvent(closeModalElement);

        this.modalContainer.setAttribute('custom-scrollbar', 'true');
        let modalBody = this.modalContainer.querySelector('.modal-body');
        if (modalBody) {
            modalBody.style.setProperty('--scrollbar-background', '#CCCCCC')
        }

        shadowRoot.appendChild(instance);

        this.style.display = '';

        return shadowRoot;
    }

    buildOpenModalClickEvent(openModalElement) {
        openModalElement.forEach((element, index) => {
            element.onclick = e => {
                this._openModal();
            }
        })
    }

    buildCloseModalClickEvent(closeModalElement) {
        if (closeModalElement) {
            closeModalElement.onclick = e => {
                this._dismissModal();
            }
        }
    }

    isShown() {
        if (this.modalContainer.classList.contains('show')) {
            return true;
        }
        return false;
    }

    _dismissModal() {
        this.modalContainer.classList.remove('show');

        document.body.style.overflow = '';
        let event = new Event('hide');
        this.shadowRoot.dispatchEvent(event);

        let galleryHotel = document.querySelector('[data-attribute="group-gallery-modal"] [data-target="gallery-hotel"]');
        if (galleryHotel) {
            galleryHotel.click();
        }
    }

    _openModal(showGalleryList) {
        this.showGalleryList = showGalleryList
        this.modalContainer.classList.remove('hide');
        this.modalContainer.classList.add('show');

        document.body.style.overflow = 'hidden';

        let event = new Event('show');
        this.shadowRoot.dispatchEvent(event);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.shadowRoot) {
            if (name == 'show') {
                if (newValue == 'visible') {
                    this._openModal(this.showGalleryList);
                } else {
                    this._dismissModal();
                }
            }
        }
    }
}
